import * as infoDeroulanteStyles from "../../../styles/admissions/admissions.module.scss";

import {faMinusCircle, faPlusCircle} from "@fortawesome/free-solid-svg-icons";
import Encadre from "./Encadre";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";
import clsx from "clsx";
import dompurify from 'isomorphic-dompurify';

const InformationDeroulante = ({title, titleBalise, content}) => {
    let [clicked, setClicked] = React.useState(false);
  const sanitizer = dompurify.sanitize;

    const RawHtml = ({children = "", tag: Tag = 'div', ...props}) => <Tag {...props}
        dangerouslySetInnerHTML={{__html: children}}/>;

    return (<>
        <div
            className={clsx(infoDeroulanteStyles.rootInfoDeroulante, {
                [infoDeroulanteStyles.infoDeroulanteClicked]: clicked,
                [infoDeroulanteStyles.infoDeroulanteNotClicked]: !clicked
            })}
        >
            <button
                onClick={() => setClicked(!clicked)}
                style={{width: "100%"}}
            >
                <div
                    className={infoDeroulanteStyles.titleListDeroulante}
                >
                    <RawHtml tag={titleBalise} className={infoDeroulanteStyles.infoDeroulanteTitle}>
                        {title}
                    </RawHtml>

                    {clicked ? (<FontAwesomeIcon
                        icon={faMinusCircle}
                        size="lg"
                        className="pointer"
                    ></FontAwesomeIcon>) : (<FontAwesomeIcon
                        icon={faPlusCircle}
                        size="lg"
                        className="pointer"
                    ></FontAwesomeIcon>)}
                </div>
            </button>
        </div>
        <div
            className={clsx(infoDeroulanteStyles.contentListDeroulante, {[infoDeroulanteStyles.contentListHidden]: !clicked})}
        >
            <Encadre>
                <div
                    className="ck-content"
                    dangerouslySetInnerHTML={{
                __html: sanitizer(content),
                    }}
                ></div>
            </Encadre>
        </div>
    </>);
};

export default InformationDeroulante;
